import { ReactQueryDynamicDevTools } from '@quickmd-llc/design-system'
import { QueryClientProvider } from '@tanstack/react-query'
import { isDevToolsEnabled } from 'features/isDevToolsEnabled'
import { type PropsWithChildren, useEffect } from 'react'
import { broadcastQueryClient } from '@tanstack/query-broadcast-client-experimental'
import { client } from 'api/components/queryClient'

export function ReactQueryProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    const isBrowser = typeof window !== 'undefined' && 'BroadcastChannel' in window
    if (!isBrowser) return
    const unsubscribe = broadcastQueryClient({
      queryClient: client,
      broadcastChannel: 'react-query',
    })

    return () => {
      unsubscribe()
    }
  }, [])

  return (
    <QueryClientProvider client={client}>
      <ReactQueryDynamicDevTools isDevToolsEnabled={isDevToolsEnabled} />
      {children}
    </QueryClientProvider>
  )
}
